<div class="dialog">
  <h4 mat-dialog-title>{{ 'dialog_leave_title' | translate }}</h4>
  <div mat-dialog-actions>
    <button type="button" mat-button (click)="onNoClick()" cdkFocusInitial>{{ 'common_btn_cancel' | translate }}</button>
    <button mat-button [mat-dialog-close]="1" color="warn" class="quit-btn">{{ 'common_btn_quit' | translate }}</button>
  </div>
</div>
